import { render, staticRenderFns } from "./WarningLeftExample.vue?vue&type=template&id=6bbc005d&scoped=true&"
import script from "./WarningLeftExample.vue?vue&type=script&lang=js&"
export * from "./WarningLeftExample.vue?vue&type=script&lang=js&"
import style0 from "./WarningLeftExample.vue?vue&type=style&index=0&id=6bbc005d&scoped=true&lang=scss&"
import style1 from "./WarningLeftExample.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc005d",
  null
  
)

export default component.exports